import {Grid} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {CheckboxInputGrid} from 'Quoting/components/shared/CheckboxInputGrid';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import {SectionLabel} from 'Quoting/components/shared/SectionLabel';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getBenefitLabelMappingforGPLU} from '../../../PlanTemplates/GWL/GWLUtilities';
import {GPLUCoverageCode} from '../../../PlanTemplates/GWL/gpluConstants';
import {getGPLUExclusionsAndLimitationsPropertyPaths, getParentPath} from '../PropertyPaths';

export const GPLUAccelDeathExclusionsAndLimitationsBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = getGPLUExclusionsAndLimitationsPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);
  const parentPath = `${getParentPath(selectedPlan?.planIndex, selectedCoverageIndex)}.exclusions`;

  const exclusionPaths = getBenefitLabelMappingforGPLU('gpluAccelDeathExclusions', parentPath);

  const hidePreExSecondaryFields = getQuoteFieldValue(propertyPaths.preExConditionLimitationCd) !== 'PreEx';

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'pre-ex-row-1'},
      title: 'PRE-EXISTING CONDITION LIMITATION',
      items: [
        {
          key: '67be3d21-1188-4f48-92fc-debdc2ac2341',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey="GPLUPreExLimitation.preExConditionLimitationCd"
              label="Pre-Ex Condition Limitation"
              id={propertyPaths.preExConditionLimitationCd}
              value={getQuoteFieldValue(propertyPaths.preExConditionLimitationCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.preExConditionLimitationCd, e.target.value)}
              coverageCode={GPLUCoverageCode.ACCEL_DEATH_BENEFIT_LIFE}
              disabled
              required
            />
          ),
        },
        {
          key: '67be3d21-1188-4f48-92fc-debdc2ac2341',
          hidden: hidePreExSecondaryFields,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey="GPLUPreExLimitation.lookBackPeriodCd"
              label="Pre-Ex Condition Lookback Period (Months)"
              id={propertyPaths.lookBackPeriodCd}
              value={getQuoteFieldValue(propertyPaths.lookBackPeriodCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.lookBackPeriodCd, e.target.value)}
              coverageCode={GPLUCoverageCode.ACCEL_DEATH_BENEFIT_LIFE}
              disabled
              required
            />
          ),
        },
      ],
    },
    {
      rowProps: {key: 'pre-ex-row-1'},
      items: [
        {
          key: '67be3d21-1188-4f48-92fc-debdc2ac2341',
          hidden: hidePreExSecondaryFields,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey="GPLUPreExLimitation.preExConditionLimitationPeriodCd"
              label="Pre-Ex Condition Limitation Period (Months)"
              id={propertyPaths.preExConditionLimitationPeriodCd}
              value={getQuoteFieldValue(propertyPaths.preExConditionLimitationPeriodCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.preExConditionLimitationPeriodCd, e.target.value)}
              coverageCode={GPLUCoverageCode.ACCEL_DEATH_BENEFIT_LIFE}
              disabled
              required
            />
          ),
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Exclusions And Limitations" collapsible withSeparator expanded>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
        <SectionLabel variant="label-only" header="Exclusions" />
        <CheckboxInputGrid state={exclusionPaths} gridLength={4} />
      </Grid>
    </FormWrapper>
  );
};
